const images = {
  landingBackground: require('../assets/images/background1.jpg'),
  logo: require('../assets/images/steyncity-logo.png'),
  stagingQr: require('../assets/images/staging-qr.png'),
  productionQr: require('../assets/images/production-qr.png'),
  developQr: require('../assets/images/develop-qr.png'),
  vendorBackground: require('../assets/images/vendor-bg.jpg'),
  invertedLogo: require('../assets/images/sc-logo-icon.png'),
};

export default images;



// WEBPACK FOOTER //
// ./src/theme/Images.ts